<!-- 空白布局 -->
<template>
  <div class="page-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods:{}
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  max-width: @max-page-width;
  min-width: @content-width;
  min-height: 100vh;
  margin: 0 auto;
  outline: 1px solid #eee;
  box-shadow: 0px 4px 4px 0px rgba(20, 86, 168, 0.06);
  // overflow: auto;
  position: relative;
}
</style>
